const handoverReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default handoverReducer;